export default function StringConverter(val) {
    if (typeof val === "string") {
        return val;
    }
    else if (!val) {
        return val;
    }
    else if (typeof val.toString === "function") {
        return val.toString();
    }
}



// WEBPACK FOOTER //
// ./src/Converters/StringConverter.ts